import { Box, Button, Typography } from '@mui/material';
import CopyEmailWrapper from '../components/CopyEmailWrapper';
import profilePicture from '../assets/profile-picture.png';
import { ContentCopy } from '@mui/icons-material';

const Main = () => (
  <Box component='main' sx={{ mb: 5, px: 2 }}>
    <Box sx={{ textAlign: 'center', mb: 7 }}>
      <Typography variant='h1' sx={{ fontSize: { xs: '3rem', sm: '9rem' } }}>
        Albert Lay
      </Typography>
      <Typography variant='h2' sx={{ fontSize: { xs: '1.25rem', sm: '2rem' } }}>
        Software Engineer
      </Typography>
    </Box>
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'center', sm: 'flex-start' },
        justifyContent: 'space-between',
        gap: 4,
      }}
    >
      <Box
        component='img'
        src={profilePicture}
        alt='My Photo'
        sx={{
          height: { xs: 120, sm: 150 },
          width: { xs: 120, sm: 150 },
          filter: 'grayscale(100%)',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.4)',
          borderRadius: '50%',
          border: '1px solid #ccc',
          objectFit: 'cover',
        }}
      />
      <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
        <Typography mb={1}>
          I want to build great software — products that delight customers, robust systems that make
          sense, and solutions that tackle real problems. I thrive in fast-paced environments,
          quickly learn new technologies and adapt seamlessly to changing requirements.
        </Typography>
        <Typography>
          Let's connect and explore how we can build impactful software together.
        </Typography>
        <Box sx={{ mt: 2 }}>
          <CopyEmailWrapper>
            <Button variant='contained' startIcon={<ContentCopy sx={{ width: 16 }} />}>
              email
            </Button>
          </CopyEmailWrapper>
        </Box>
      </Box>
    </Box>
  </Box>
);

export default Main;
